<template>
  <div class="input-group">
    <div class="input-title">On Max retry, jump to page</div>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-b-0">
        <v-radio-group v-model="property.type" grow dense hide-details>
          <v-radio value="default" label="Default max retry page"></v-radio>

          <v-radio class="radio-top" value="page">
            <template v-slot:label>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 d-flex">
                  <v-select
                    class="m-auto"
                    v-model="property.page"
                    :items="tabFilter"
                    item-text="name"
                    item-value="id"
                    label="Go to page"
                    :disabled="property.type !== 'page'"
                    dense
                    hide-details
                  ></v-select>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="m-l-10"
                        :disabled="!property.page"
                        @click="goToPage(property.page)"
                      >
                        fa-arrow-up-right-from-square
                      </v-icon>
                    </template>
                    <span>Open page</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
          </v-radio>

          <v-radio class="radio-top" value="component">
            <template v-slot:label>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-r-35 d-flex">
                  <v-select
                    class="shift-m-t"
                    v-model="property.component"
                    :items="itemFilter"
                    item-text="name"
                    item-value="id"
                    label="Jump to component"
                    :disabled="property.type !== 'component'"
                    dense
                    hide-details
                  >
                    <template v-slot:selection="{ attrs, item }">
                      <div class="d-flex align-center">
                        <div class="width25px text-center m-r-5">
                          <v-icon small>{{ item.icon }}</v-icon>
                        </div>
                        {{ item.name }}
                      </div>
                    </template>
                    <template v-slot:item="{ index, item }">
                      <v-list-item-content class="list-icon">
                        <div class="d-flex">
                          <div class="width25px text-center m-r-5">
                            <v-icon small>{{ item.icon }}</v-icon>
                          </div>
                          {{ item.name }}
                        </div>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'

import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    items: Array,
    tabs: Array
  },
  components: {
    NoteComponent
  },
  data() {
    return {
      property: {},
      tabFilter: [],
      itemFilter: []
    }
  },
  created() {
    this.property = this.node.property
    const tabFilter = _.filter(this.tabs, o => o.name !== 'Home')

    this.tabFilter = _.sortBy(tabFilter, [
      function(o) {
        return o.name.toLowerCase()
      }
    ])

    const itemFilter = _.filter(this.items, o => {
      return this.$nodeNoJump.indexOf(o.type) === -1
    })

    this.itemFilter = _.sortBy(itemFilter, [
      function(o) {
        return o.name.toLowerCase()
      }
    ])
  },
  methods: {
    goToPage(pageId) {
      this.$emit('goToPage', pageId)
    }
  }
}
</script>

<style scoped lang="scss">
.body-dialog {
  margin: 10px !important;
}

.margin-radio {
  margin-top: 10px;
}

::v-deep .v-radio.radio-top {
  align-items: baseline !important;
}
</style>
